"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerBiReportClient = void 0;
const BaseClient_1 = require("../BaseClient");
/**
 * @deprecated - use logi-reports library instead
 */
class PowerBiReportClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    getEmbedToken(reportId, allowEdit, partition, allowSaveAs) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/powerbi/reports/token',
                params: {
                    reportId,
                    allowEdit,
                    allowSaveAs,
                    partition,
                },
            });
            return response.data;
        });
    }
    refreshDataset(datasetId, partition) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/powerbi/reports/refreshDataset',
                params: {
                    datasetId,
                    partition,
                },
            });
        });
    }
    listReports(partition) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/powerbi/reports/list',
                params: {
                    partition,
                },
            });
            return response.data;
        });
    }
    requestExport(exportRequest, reportId, partition) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/powerbi/reports/export',
                params: {
                    reportId,
                    partition,
                },
                data: exportRequest,
            });
            return response.data;
        });
    }
    getExportStatus(reportId, exportId, partition) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/powerbi/reports/export-status',
                params: {
                    reportId,
                    exportId,
                    partition,
                },
            });
            return response.data;
        });
    }
    getExportFileUrl(reportId, exportId, partition, downloadFileName) {
        const url = new URL(`${this.axiosInstance.defaults.baseURL}/api/v1/powerbi/reports/export-file`);
        url.searchParams.append('reportId', reportId);
        url.searchParams.append('exportId', exportId);
        if (partition) {
            url.searchParams.append('partition', partition);
        }
        if (downloadFileName) {
            url.searchParams.append('downloadFileName', downloadFileName);
        }
        return url.href;
    }
}
exports.PowerBiReportClient = PowerBiReportClient;
